// ═══════════════════════════════════════════════════════════════════════════════
// Compact language selector (dropdown)
// ═══════════════════════════════════════════════════════════════════════════════

import { useCallback, useId, type ChangeEvent } from 'react';
import { getLanguageNativeLabel, SUPPORTED_LANGUAGES, type Language } from '@fdh/shared';
import { useLanguage } from '../contexts/LanguageContext';

type LanguageSwitcherProps = {
  className?: string;
};

export const LanguageSwitcher = ({ className = '' }: LanguageSwitcherProps) => {
  const selectId = useId();
  const { language, setLanguage, t } = useLanguage();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      setLanguage(event.target.value as Language);
    },
    [setLanguage],
  );

  return (
    <div className={className}>
      <label htmlFor={selectId} className="sr-only">
        {t('common.languageSwitcherAria')}
      </label>
      <select
        id={selectId}
        value={language}
        onChange={handleChange}
        aria-label={t('common.languageSwitcherAria')}
        className="min-w-[9rem] rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm font-medium text-gray-700 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
      >
        {SUPPORTED_LANGUAGES.map((opt) => (
          <option key={opt} value={opt}>
            {getLanguageNativeLabel(opt)}
          </option>
        ))}
      </select>
    </div>
  );
};
